import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';

@BindAll()
export class LexiangController {
  /** 获取code */
  async getCodeByAppId(body) {
    return await AjaxBasics.request({
      ...EnumAPI.lexiang_oauth_code_tokenAndAppId,
      body,
      loading: false,
      interceptErrMsg: true,
    });
  }

  /** 同意隐私 */
  async onPrivacyAgree(body) {
    return await AjaxBasics.request({
      ...EnumAPI.lexiang_privacy_agree,
      body,
      loading: false,
    });
  }
}
